var parseAddress = require('./parse-address');
var DIRECTIONAL  = require('./directional');
var STREET_TYPES = require('./street-types');
var STATE_CODES  = require('./states').STATE_CODES;
var md5          = require('./md5');
var isString     = require('./is-string');
var he           = require('he');
// var intersection = require('./intersection');
// var pick         = require('./pick');
// var uniq         = require('./uniq');


///////////////////////////////
// Class
///////////////////////////////

function Address(address) {
    var parts;

    if(typeof address == 'string') {
        this._orgAddress = address;
        address = he.decode(address).replace(/<\/{0,1}\w+\/{0,1}>/gi, '').replace(/([()])/gi, '').replace(/\s#/i, ' Unit ');
        this._heDecodedAddress = address;
        parts = this._parseAddress(address);
    } else {
        this._orgAddress = formatAddress(address);
        parts = this._parseAddress(this._orgAddress);
    }

    Object.keys(parts).forEach((function (k) {
        this[k] = parts[k];
    }).bind(this));

    this._isValid = isValidAddress(this);
}

///////////////////////////////
// Static Functions
///////////////////////////////

/**
 * commented out because it needs to be
 * refactored with less duplicate code
 */
// Address.isSame = isSame;

/**
 * @function isValid
 * @param {String} address
 */

Address.isValid = function (address) {
    var parts = new Address(address);
    return isValidAddress(parts);
};

/**
 * @function isSame
 * @param {String} address1
 * @param {String} address2
 */

Address.isSame = isSame;

///////////////////////////////
// Private Functions
///////////////////////////////

Address.prototype._format = function _format() {
    if(!this._isValid) return this._orgAddress;
    return formatAddress(this);
};

Address.prototype._parseAddress = function _parseAddress() {
    return parseAddress.apply(parseAddress, arguments);
};

///////////////////////////////
// Public Functions
///////////////////////////////

Address.prototype.toString = function toString() {
    return this._format();
};

Address.prototype.normalize = function normalize() {
    return normalizeAddress(this);
};

Address.prototype.hash = function hash() {
    if(!this._isValid) return md5(this._orgAddress);
    return md5(this.normalize());
};

Address.prototype.getParts = function getParts() {
    return {
        number: this.number,
        prefix: this.prefix,
        street: this.street,
        type: this.type,
        suffix: this.suffix,
        sec_unit_type: this.sec_unit_type,
        sec_unit_num: this.sec_unit_num,
        city: this.city,
        state: this.state,
        zip: this.zip
    };
};

Address.prototype.getNormalizedParts = function getNormalizedParts() {
    return {
        number: this.number,
        prefix: this.prefix ? DIRECTIONAL[this.prefix.toLowerCase()] : undefined,
        street: this.street ? this.street.toLowerCase() : undefined,
        type: this.type ? (STREET_TYPES[this.type.toLowerCase()] || this.type).toLowerCase() : undefined,
        suffix: this.suffix ? DIRECTIONAL[this.suffix.toLowerCase()] : undefined,
        sec_unit_type: this.sec_unit_num ? '#' : undefined,
        sec_unit_num: this.sec_unit_num ? this.sec_unit_num.toLowerCase() : undefined,
        city: this.city ? this.city.toLowerCase() : undefined,
        state: this.state ? (STATE_CODES[this.state.toLowerCase()] || this.state).toLowerCase() : undefined,
        zip: this.zip
    };
};

Address.prototype.isSame = function _isSame(address2) {
    if(!isString(address2)) address2 = address2._orgAddress;

    return isSame(this._orgAddress, address2);
};


///////////////////////////////
// Functions
///////////////////////////////

function isSame(address1, address2) {
    address1 = new Address(address1.toLowerCase());
    address2 = new Address(address2.toLowerCase());
    var streetNumberIsSame = address1.number == address2.number;
    var streetNameIsSame = address1.street == address2.street;
    var stateIsSame = address1.state == address2.state;
    var zipIsSame = address1.zip == address2.zip;
    var testFunctions = [
        doTheHashesMatch,
        wrongZip,
        wrongCity,
        missingOrChangedStreetPrefix,
        missingOrChangedStreetSuffix,
        missingOrChangedStreetType,
        aptMissMatch
    ];

    return testFunctions.some(function (func) {
        return func(address1, address2);
    });


    function doTheHashesMatch(address1, address2) {
        return address1.hash() === address2.hash();
    }

    function wrongZip(address1, address2) {
        var zipIsCloseEnough = address1.zip && address2.zip && address1.zip.substr(0,3) == address2.zip.substr(0,3) && address1.zip !== address2.zip;

        return streetNumberIsSame && streetNameIsSame && stateIsSame && zipIsCloseEnough;
    }

    function wrongCity(address1, address2) {
        var cityIsDifferent = address1.city != address2.city;

        return streetNumberIsSame && streetNameIsSame && stateIsSame && zipIsSame && cityIsDifferent;
    }

    function missingOrChangedStreetPrefix(address1, address2) {
        var missingPrefix = (!address1.prefix && address2.prefix) || (address1.prefix && !address2.prefix);
        var changedPrefix = address1.prefix != address2.prefix;

        return streetNumberIsSame && streetNameIsSame && stateIsSame && zipIsSame && (missingPrefix || changedPrefix);
    }

    function missingOrChangedStreetSuffix(address1, address2) {
        var missingSuffix = (!address1.suffix && address2.suffix) || (address1.suffix && !address2.suffix);
        var changedSuffix = address1.suffix != address2.suffix;

        return streetNumberIsSame && streetNameIsSame && stateIsSame && zipIsSame && (missingSuffix || changedSuffix);
    }

    function missingOrChangedStreetType(address1, address2) {
        var missingType = (!address1.type && address2.type) || (address1.type && !address2.type);
        var changedType = address1.type != address2.type;

        return streetNumberIsSame && streetNameIsSame && stateIsSame && zipIsSame && (missingType || changedType);
    }

    function aptMissMatch(address1, address2) {
        var apt1 = address1.sec_unit_num;
        var apt2 = address2.sec_unit_num;

        if(apt1 === apt2) return false;

        if(apt1) {
            return !!address2.street.match(apt1) && streetNumberIsSame && stateIsSame && zipIsSame;
        } else {
            return !!address1.street.match(apt2) && streetNumberIsSame && stateIsSame && zipIsSame;
        }
    }
}

function formatAddress(parts) {
    if(parts.sec_unit_type != '#') parts.sec_unit_type += ' ';

    var formatted = '';
    if(parts.number) formatted += parts.number;
    if(parts.prefix) formatted += ' ' + parts.prefix;
    if(parts.street) formatted += ' ' + parts.street;
    if(parts.type) formatted += ' ' + parts.type;
    if(parts.suffix) formatted += ' ' + parts.suffix;
    if(parts.sec_unit_num) formatted += ' ' + parts.sec_unit_type + parts.sec_unit_num;
    formatted += ',';
    if(parts.city) formatted += ' ' + parts.city;
    formatted += ',';
    if(parts.state) formatted += ' ' + parts.state;
    if(parts.zip) formatted += ' ' + parts.zip;

    return formatted;
}

function normalizeAddress(parts) {
    parts.sec_unit_type = '#';

    if(!parts._isValid) throw new Error('Cannot normalize invalid address');

    var formatted = '';
    if(parts.number) formatted += parts.number;
    if(parts.prefix) formatted += ' ' + DIRECTIONAL[parts.prefix.toLowerCase()];
    if(parts.street) formatted += ' ' + parts.street;
    if(parts.type) formatted += ' ' + (STREET_TYPES[parts.type.toLowerCase()] || parts.type);
    if(parts.suffix) formatted += ' ' + DIRECTIONAL[parts.suffix.toLowerCase()];
    if(parts.sec_unit_num) formatted += ' ' + parts.sec_unit_type + parts.sec_unit_num;
    if(parts.city) formatted += ' ' + parts.city;
    if(parts.state) formatted += ' ' + (STATE_CODES[parts.state.toLowerCase()] || parts.state);
    if(parts.zip) formatted += ' ' + parts.zip;

    return (formatted || '').toLowerCase();
}

function isValidAddress(parts) {
    return !!(
        parts.number &&
        parts.street &&
        parts.city &&
        parts.state
    );
}

module.exports = Address;
